import InternalChatAPI from 'dashboard/api/internalChat';

const replyContext = async (channelId, target, current) => {
  const { data: parent } = await InternalChatAPI.getMessage(
    channelId,
    target.parent_id
  );
  if (!current()) return null;
  let root = parent;
  while (root.parent_id && !root.content_attributes?.also_send_in_channel) {
    // Each ancestor is learned from the preceding authorized response.
    // eslint-disable-next-line no-await-in-loop
    const { data: ancestor } = await InternalChatAPI.getMessage(
      channelId,
      root.parent_id
    );
    if (!current()) return null;
    root = ancestor;
  }
  return { parent, root };
};

export const navigationActions = {
  async openMessage({ state, commit, dispatch }, { channelId, messageId }) {
    if (!state.channels.some(channel => channel.id === channelId)) return null;
    commit('SET_SELECTED_CHANNEL', channelId);
    const generation = state.contextGeneration;
    const selection = state.channelSelectionGeneration;
    let threadGeneration = state.threadState.generation;
    let replyTarget = false;
    const ownsThread = () => threadGeneration === state.threadState.generation;
    const current = () =>
      generation === state.contextGeneration &&
      selection === state.channelSelectionGeneration &&
      channelId === state.selectedChannelId &&
      state.channels.some(channel => channel.id === channelId);
    commit('SET_UI_FLAG', { isNavigatingMessage: true });
    commit('SET_ERROR', { navigation: null });
    try {
      const { data: target } = await InternalChatAPI.getMessage(
        channelId,
        messageId
      );
      if (!current()) return null;
      const parentId = target.parent_id;
      replyTarget = !!parentId;
      if (parentId && !ownsThread()) return null;
      const resolved = parentId
        ? await replyContext(channelId, target, () => current() && ownsThread())
        : { parent: null, root: target };
      if (!resolved || !current()) return null;
      const { parent, root } = resolved;
      await Promise.all([
        dispatch('fetchMessages', {
          channelId,
          params: { around_id: root.id },
        }),
        dispatch('fetchMembers', channelId),
        dispatch('markRead', channelId),
        dispatch('fetchDraft', { channelId }),
      ]);
      if (!current()) return null;
      if (state.messageMeta[channelId]?.context_id !== root.id) return null;
      if (parentId) {
        if (!ownsThread()) return null;
        const opening = dispatch('fetchThread', {
          channelId,
          messageId: parentId,
          parent,
          params: { around_id: target.id },
        });
        threadGeneration = state.threadState.generation;
        await opening;
      }
      if (!current()) return null;
      if (parentId && !ownsThread()) return null;
      if (parentId && state.thread?.meta.context_id !== target.id) return null;
      commit('SET_NAVIGATION_TARGET', {
        id: target.id,
        channel_id: channelId,
        parent_id: target.parent_id,
        root_id: root.id,
      });
      return target;
    } catch (error) {
      if (!current() || (replyTarget && !ownsThread())) return null;
      commit('SET_ERROR', { navigation: error });
      throw error;
    } finally {
      if (current()) commit('SET_UI_FLAG', { isNavigatingMessage: false });
    }
  },
};
